import { Award, Shield, Star, Users, MapPin } from "lucide-react";

interface TrustStripProps {
  /** Use 'dark' on navy/dark backgrounds, 'light' on white. */
  tone?: "dark" | "light";
  className?: string;
}

const items = [
  { icon: Award, label: "CPA · CTRS" },
  { icon: Shield, label: "ASTPS Gold Member" },
  { icon: Star, label: "4.9★ Google Reviews" },
  { icon: Users, label: "15+ Years Experience" },
  { icon: MapPin, label: "All 50 States" },
];

/**
 * Compact trust signal row. Lives above the fold on service / category /
 * landing pages to reassure prospects before they scroll.
 */
export const TrustStrip = ({ tone = "dark", className = "" }: TrustStripProps) => {
  const isDark = tone === "dark";
  return (
    <ul
      className={`flex flex-wrap lg:flex-nowrap items-center gap-x-5 gap-y-2 text-[12px] font-semibold uppercase tracking-[0.08em] ${
        isDark ? "text-white/85" : "text-navy"
      } ${className}`}
    >
      {items.map((it, i) => {
        const Icon = it.icon;
        return (
          <li key={it.label} className="flex items-center gap-1.5 whitespace-nowrap">
            <Icon className="w-3.5 h-3.5 text-gold" />
            <span>{it.label}</span>
            {i < items.length - 1 && (
              <span
                aria-hidden
                className={`ml-3 hidden sm:inline-block h-3 w-px ${
                  isDark ? "bg-white/20" : "bg-border"
                }`}
              />
            )}
          </li>
        );
      })}
    </ul>
  );
};
